import wrapRootElement from './src/components/wrap-root-element';

export { wrapRootElement };
